/**
 * Minimal markdown rendering for agent-written articles (seo_writer emits
 * `##` headings, plain paragraphs, occasional `- ` lists and **bold**). Not a
 * general markdown engine on purpose — everything else renders as text.
 * Both call sites nest under an h3 card title, so `##` maps to h4, deeper
 * levels to h5 (preserves the document outline).
 */

function inline(text: string): React.ReactNode[] {
  return text.split(/\*\*([^*]+)\*\*/g).map((part, i) => (i % 2 === 1 ? <strong key={i}>{part}</strong> : part));
}

export function ArticleBody({ markdown }: { markdown: string }) {
  const blocks = markdown.split(/\n{2,}/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className="article">
      {blocks.map((block, i) => {
        const heading = /^(#{1,6})\s+(.*)$/.exec(block);
        if (heading) {
          const Tag = heading[1]!.length <= 2 ? 'h4' : 'h5';
          return (
            <Tag key={i} style={{ margin: '18px 0 4px' }}>
              {inline(heading[2]!)}
            </Tag>
          );
        }
        const lines = block.split('\n');
        if (lines.every((l) => /^[-*]\s+/.test(l))) {
          return (
            <ul key={i} style={{ margin: '8px 0', paddingLeft: 22 }}>
              {lines.map((l, j) => (
                <li key={j}>{inline(l.replace(/^[-*]\s+/, ''))}</li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i} style={{ margin: '8px 0', whiteSpace: 'pre-wrap' }}>
            {inline(block)}
          </p>
        );
      })}
    </div>
  );
}
